import React, { useEffect, useRef } from 'react';
import './css/qa_Chat.scss';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { IoPaperPlane } from '../../components/icons';
// import { Scrollbars } from 'react-custom-scrollbars';
import { DEMO_USER_PICTURE, getCurrentTime, getLocalStorage, log } from '../../common/common';
import appConfig from '../../config/config';
import { useState } from 'react';

import axiosInstance from '../../Store/helper/axiosInstance';
import { isMobile } from 'react-device-detect';
import PollCardV1 from '../cards/poll/pollCardV1/PollCardV1d';
import PollCardCompleted from '../cards/poll/pollCardV1/PollCardCompleted';
import { useDispatch } from 'react-redux';
import { getPollOfLiveCme, sendLiveSessionPageViewTime } from '../../Store/actions/session.action';
import LazyImage from '../CustomLibraries/LazyImage';
const url = appConfig.apiLoc;
let userDetails;
let evtSource = '';
let commentsDataTemp = [];
let surveyDataTemp = [];
let counter = 0;
let pollData = [];
const colors = ['#39c9bc', '#117d9d', '#b5720d'];
const randIndex = Math.floor(Math.random() * colors.length);

const QuestionAnswerChat = ({ type, id }) => {
  const scrollRef = useRef(null);
  // const [commentsData, setCommentsData] = useState([]);
  // const [isPollShow, setIsPollShow] = useState(false);
  // const [isAnsShow, setIsAnsShow] = useState(false);
  // const [isAnswered, setIsAnswered] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showPoll, setShowPoll] = useState(false);
  const [showAns, setShowAns] = useState(false);
  const [pollId, setPollId] = useState('');
  const [pollData, setPollData] = useState([]);
  const [commentValue, setCommentValue] = useState('');
  const [seeMore, setSeeMore] = useState(false);
  const [render, setRender] = useState(false);
  const [submittingData, setSubmittinData] = useState([]);
  const [justAnswered, setJustAnswered] = useState(false);
  const [heartbeatLogId, setHeartbeatLogId] = useState(0);
  const dispatch = useDispatch();
  const refresh = () => setRender(!render);
  function scrollToBottom() {
    if (scrollRef.current) {
      scrollRef?.current?.scrollToBottom();
    }
  }
  function getLivePollData(survey_ids, cb) {
    dispatch(
      getPollOfLiveCme(survey_ids, (res) => {
        res != 'error' && cb(res?.data);
      })
    );
  }
  function loopThroughSurvey(surveyList) {
    console.log('surveyList', surveyList);
    for (const _s of surveyList) {
      if (_s.is_anwered) {
        console.log('====>>>IN ANSWERED');
        setSubmittinData((_prev) => {
          console.log('prev', _prev);
          return [..._prev, _s.survey_id];
        });
      }
      if (_s.is_show == 0 && _s.is_answer_show == 0) {
        setShowPoll(false);
        setShowAns(false);
        setPollId('');
      } else if (_s.is_show == 1 && _s.is_answer_show == 0) {
        getLivePollData(surveyList?.map((_p) => _p.survey_id).join(), (_data) => {
          setPollData(_data);
          setShowPoll(true);
          setShowAns(false);
          setPollId(_s.survey_id);
          scrollToBottom();
        });

        break;
      } else if (_s.is_show == 0 && _s.is_answer_show == 1) {
        getLivePollData(surveyList?.map((_p) => _p.survey_id).join(), (_data) => {
          log('ANSWER DATA', _data);
          if (!_data?.some((_d) => _d.survey_id == _s.survey_id && _d.result_data == 'null')) {
            setPollData(_data);
            setShowPoll(false);
            setShowAns(true);
            setPollId(_s.survey_id);
            scrollToBottom();
          }
        });

        break;
      }
    }
  }
  useEffect(() => {
    if (type == 'session') {
      let currentTime = getCurrentTime;
      const tempJson = { start_time: currentTime, page_id: id };
      dispatch(
        sendLiveSessionPageViewTime(tempJson, (res) => {
          const { data } = res;
          console.log('session time reported', data);
          if (data && data != 0) {
            console.log('HeartBeatLogid get successfull:::', data);
            setHeartbeatLogId(data);
          }
        })
      );
    }
  }, []);

  useEffect(() => {
    // console.log('event source effect called:', evtSource?.readyState);
    scrollToBottom();
    userDetails = getLocalStorage('user', {});
    const token = getLocalStorage('refreshToken', true);
    const sourceUrl = `${url}openapi/sse?token=${token}&type_id=${id}&type=${type}&log_id=${heartbeatLogId}`;
    if (evtSource && evtSource?.readyState == 0) {
      console.log('event source effect called:', 'previous event source called');
      evtSource.close();
    }
    evtSource = new EventSource(sourceUrl);
    if (typeof EventSource !== 'undefined') {
      evtSource.onmessage = function (event) {
        console.log('event', event);
        let tempResData = JSON.parse(event.data);
        console.log('parsedata', tempResData);
        if (tempResData?.survey_data?.length > 0) {
          log('RESPONSE SSE EVENT SURVEY', tempResData.survey_data);
          if (counter == 0) {
            surveyDataTemp = tempResData?.survey_data;
            counter++;
            loopThroughSurvey(tempResData?.survey_data);
            // getLivePollData(
            //   tempResData.survey_data?.map((_p) => _p.survey_id).join(),
            //   (_data) => {
            //     setPollData(_data);
            //     counter++;
            //   },
            // );
          }
          if (JSON.stringify(surveyDataTemp) === JSON.stringify(tempResData?.survey_data)) {
            // console.log('====>>>SAME');
          } else {
            console.log('====>>>NOT SAME');
            surveyDataTemp = tempResData?.survey_data;
            loopThroughSurvey(surveyDataTemp);
          }
        }
        if (tempResData?.comment_data?.length > 0) {
          commentsDataTemp = tempResData?.comment_data;
          // console.log('COMMENT DATA', commentsDataTemp);
          refresh();
        }
      };
    } else {
      console.log('sorry, your browser does not support server-sent events...');
      evtSource.close();
    }
    return () => {
      if (evtSource) {
        evtSource.close();
      }
    };
  }, [commentsDataTemp?.length, heartbeatLogId]);
  // commentsDataTemp?.length

  useEffect(() => {
    if (justAnswered) {
      setTimeout(() => {
        setJustAnswered(false);
      }, 5000);
    }
  }, [justAnswered]);

  const submitComment = (e) => {
    let firstName = userDetails?.first_name;
    let lastName = userDetails?.last_name;
    if (commentValue) {
      setDisabled(true);
      let tempCommentsData = {
        comment: commentValue,
        type_id: id,
        type: type
      };
      axiosInstance
        .post('knwlgmastersessionnew/submitsessioncomment', tempCommentsData)
        .then((res) => {
          setDisabled(false);
          log('POST RESPONSE', res.data);
          if (res.data.status_code == 200) {
            let newCommentsdata = {
              //knwlg_session_qna_id: res.data.data.insert_id,
              first_name: firstName,
              last_name: lastName,
              comment: commentValue,
              profile_image: userDetails?.profile_image
            };
            commentsDataTemp.push(newCommentsdata);
            setCommentValue('');
            scrollToBottom();
          }
        })
        .catch((e) => {
          setDisabled(false);
          log('Error'), e;
        });
    }
  };

  // function isValidUrl(string) {
  //   try {
  //     new URL(string);
  //     return true;
  //   } catch (err) {
  //     return false;
  //   }
  // }

  return (
    <div className="w-100 text-start qa_chat position-relative h-100 d-flex flex-column">
      {isMobile && justAnswered && (
        <div className="w-100 alert alert-success fw-semibold mb-2 text-center border">
          Thank you for participating in the poll
        </div>
      )}
      {isMobile &&
        pollData?.length > 0 &&
        (showPoll && pollId && !submittingData?.some((_d) => _d == pollId) ? (
          <>
            <div className="w-100 alert alert-info fw-semibold m-0 text-center border">
              Please Select a option below
            </div>
            <div className="w-100 mt-3">
              <PollCardV1
                data={pollData.find((_p) => _p.survey_id == pollId)}
                isCme={true}
                setJustAnswered={setJustAnswered}
              />
            </div>
          </>
        ) : showAns && pollId ? (
          <>
            <div className="w-100 alert alert-info fw-semibold m-0 text-center border">
              Poll results are showing below
            </div>
            <div className="w-100 mt-3">
              <PollCardCompleted
                data={pollData.find((_p) => _p.survey_id == pollId)}
                isCme={true}
              />
            </div>
          </>
        ) : null)}
      <h4 className="qa_chatTtl fs-3 fw-normal text-white bg-primary py-0 px-3 d-none d-md-flex align-items-center">
        Questions &amp; Answers
      </h4>
      {/* <div className="w-100 qa_chatBox position-relative pb-50"> */}
      <div
        className="w-100 qa_chatArea py-3 px-3 px-md-2 overflow-y-scroll bg-transparent h-100 d-flex flex-column"
        id="chatArea"
      >
        {!isMobile ? (
          <>
            {/* <Scrollbars autoHideTimeout={1000} autoHideDuration={200} ref={scrollRef}> */}
            {
              commentsDataTemp.length > 0
                ? commentsDataTemp.map((_com, index) => (
                  <div
                    className="w-100 qa_ChatRowIn position-relative d-inline-flex mb-3"
                    key={index + 1}
                  >
                    <div
                      className="rounded-circle qa_Chatv1Pic d-flex justify-content-center align-items-center position-relative overflow-hidden"
                      style={{ backgroundColor: colors[randIndex] }}
                    >
                      {_com?.profile_image ? (
                        <>
                          {/* {console.log('profile image', userDetails.profile_image)} */}
                          <LazyImage
                            src={_com?.profile_image}
                            className="w-100 h-100 object-fit-cover"
                            fallback_image={DEMO_USER_PICTURE}
                          />
                        </>
                      ) : (
                        <h6 className="fw-semibold text-white fs-2 text-uppercase">
                          {_com?.first_name?.charAt(0).toUpperCase()}
                        </h6>
                      )}
                      {/* <h6 className="fw-semibold text-white fs-2 text-uppercase">
                          {_com?.first_name?.charAt(0).toUpperCase()}
                        </h6> */}
                    </div>
                    <span className="singleCommentGraph"></span>
                    <div className="qa_ChatContent ps-4">
                      <div className="fs-4 qa_ChatContentMain d-inline-block py-2 px-3 position-relative">
                        <h4 className="fs-4 fw-normal text-black qa_Chatv1PostBy">
                          Dr. {_com.first_name} {_com.last_name}
                        </h4>
                        <p>{_com.comment}</p>
                      </div>
                    </div>
                  </div>
                ))
                : null
              // <div className="w-100 text-danger alert alert-danger fw-semibold m-0 text-center">
              //   Please post your questions/comments here
              // </div>
            }
            {justAnswered && (
              <div className="w-100 alert alert-success fw-semibold m-0 text-center border">
                Thank you for participating in the poll
              </div>
            )}
            {pollData?.length > 0 &&
              (showPoll && pollId && !submittingData?.some((_d) => _d == pollId) ? (
                <>
                  <div className="w-100 alert alert-info fw-semibold m-0 text-center border">
                    Please Select a option below
                  </div>
                  <div className="w-100 mt-3">
                    <PollCardV1
                      data={pollData.find((_p) => _p.survey_id == pollId)}
                      isCme={true}
                      setJustAnswered={setJustAnswered}
                    />
                  </div>
                </>
              ) : showAns && pollId ? (
                <>
                  <div className="w-100 alert alert-info fw-semibold m-0 text-center border">
                    Poll results are showing below
                  </div>
                  <div className="w-100 mt-3">
                    <PollCardCompleted
                      data={pollData.find((_p) => _p.survey_id == pollId)}
                      isCme={true}
                    />
                  </div>
                </>
              ) : null)}

            {/* </Scrollbars> */}
          </>
        ) : (
          <>
            {commentsDataTemp.length > 0 ? (
              !seeMore ? (
                <>
                  <div className="w-100 qa_ChatRowIn position-relative d-inline-flex mb-3">
                    <div
                      className="rounded-circle qa_Chatv1Pic d-flex justify-content-center align-items-center position-relative overflow-hidden"
                      style={{ backgroundColor: colors[randIndex] }}
                    >
                      {commentsDataTemp[0]?.profile_image ? (
                        <>
                          <LazyImage
                            src={commentsDataTemp[0]?.profile_image}
                            className="w-100 h-100 object-fit-cover"
                            fallback_image={DEMO_USER_PICTURE}
                          />
                        </>
                      ) : (
                        <h6 className="fw-semibold text-white fs-2 text-uppercase">
                          {commentsDataTemp[0]?.first_name?.charAt(0).toUpperCase()}
                        </h6>
                      )}

                    </div>
                    <span className="singleCommentGraph"></span>
                    <div className="qa_ChatContent ps-4">
                      <div className="fs-4 qa_ChatContentMain bg-white d-inline-block py-2 px-3 position-relative">
                        <h4 className="fs-4 fw-normal text-black qa_Chatv1PostBy">
                          Dr. {commentsDataTemp[0].first_name} {commentsDataTemp[0].last_name}
                        </h4>
                        <p>{commentsDataTemp[0].comment}</p>
                      </div>
                    </div>
                  </div>
                  {commentsDataTemp?.length > 1 && (
                    <div className="w-100 text-end">
                      <h2 className="text-primary mt-3 fs-4" onClick={() => setSeeMore(true)}>
                        See More
                      </h2>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {commentsDataTemp.map((_com, index) => (
                    <div
                      className="w-100 qa_ChatRowIn position-relative d-inline-flex mb-3"
                      key={index + 1}
                    >
                      <div
                        className="rounded-circle qa_Chatv1Pic d-flex justify-content-center align-items-center position-relative overflow-hidden"
                        style={{ backgroundColor: colors[randIndex] }}
                      >
                        {_com?.profile_image ? (
                          <>
                            <LazyImage
                              src={_com?.profile_image}
                              className="w-100 h-100 object-fit-cover"
                              fallback_image={DEMO_USER_PICTURE}
                            />
                          </>
                        ) : (
                          <h6 className="fw-semibold text-white fs-2 text-uppercase">
                            {_com?.first_name?.charAt(0).toUpperCase()}
                          </h6>
                        )}

                      </div>
                      <span className="singleCommentGraph"></span>
                      <div className="qa_ChatContent ps-4">
                        <div className="fs-4 qa_ChatContentMain bg-white d-inline-block py-2 px-3 position-relative">
                          <h4 className="fs-4 fw-normal text-black qa_Chatv1PostBy">
                            Dr. {_com.first_name} {_com.last_name}
                          </h4>
                          <p>{_com.comment}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="w-100 text-end">
                    <h2 className="text-primary mt-3" onClick={() => setSeeMore(false)}>
                      See Less
                    </h2>
                  </div>
                </>
              )
            ) : null}
          </>
        )}
      </div>

      <div className="qa_chatFrm w-100 bg-light d-flex justify-content-between align-items-center px-2 mt-auto">
        <div className="rounded-circle qaChatFrmUser overflow-hidden">
          {userDetails?.profile_image ? (
            <LazyImage
              src={userDetails?.profile_image}
              alt="profile image"
              className="object-fit-cover w-100 h-100 float-start"
              fallback_image={
                'https://firebasestorage.googleapis.com/v0/b/clirnetapp.appspot.com/o/doctor%2F0E57DB94-9662-11F6-3541-148D6F42BDC8%2F0E57DB94-9662-11F6-3541-148D6F42BDC8167242955049480.png?alt=media&token=1754cd39-f142-4ad9-aca8-8cc102dfe88f'
              }
              logo
            />
          ) : (
            <h6 className="fw-semibold text-white fs-2 text-uppercase">
              {userDetails?.first_name?.charAt(0).toUpperCase()}
            </h6>
          )}

          {/* <h6 className="fw-semibold text-white fs-2 text-uppercase">A</h6> */}
        </div>

        <Form.Floating className="position-relative overflow-hidden">
          <Form.Control
            className="fs-4 fw-semibold border-0 p-0 rounded-pill px-4"
            id="floatingInputCustom"
            type="text"
            placeholder="Write a comment here"
            value={commentValue}
            onChange={(e) => {
              setCommentValue(e.target.value);
            }}
            onKeyPress={(e) => {
              if (e.key == 'Enter') {
                submitComment();
              }
            }}
          />
          <label htmlFor="floatingInputCustom fw-semibold">Write a comment here</label>
        </Form.Floating>
        <Button
          type="submit"
          disabled={disabled}
          className="rippleEffect rounded-circle btn btn-secondary fs-4 d-flex justify-content-center align-items-center p-3"
          onClick={submitComment}
          aria-label="Submit Comment"
        >
          <IoPaperPlane customClass="fs-1" />
        </Button>
      </div>
      {/* </div> */}
    </div>
  );
};

export default QuestionAnswerChat;
